import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import * as React from 'react'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { IDemographics } from 'types/IDemographics'
import { Dropdown } from 'components/dropdown'
import translations from 'locales/de.yml'

interface IDemographicsHandlers {
  handleAgeUpdate: (age: Age) => void
  handleGenderUpdate: (gender: Gender) => void
  handleEducationUpdate: (education: Education) => void
  handleSkip: () => void
}

export const Demographics = ({
  age,
  gender,
  education,
  handleAgeUpdate,
  handleGenderUpdate,
  handleEducationUpdate,
  handleSkip
}: Partial<IDemographics> & IDemographicsHandlers) => (
  <div style={{ zIndex: 100 }}>
    <h3 className='ui purple header'>Demografische Angaben</h3>
    <div className='ui form vertical segment'>
      <div className='ui grid'>
        <div className='stackable doubling three column row'>
          <div className='column'>
            <div className='grouped fields' id={'age'}>
              <label htmlFor='age'>Alter</label>
              <Dropdown
                changeHandler={val => handleAgeUpdate(val as Age)}
                options={Object.values(Age).map(age => ({
                  value: age,
                  text: translations['Age'][age]
                }))}
                currentValue={age}
              />
            </div>
          </div>
          <div className='column'>
            <div className='grouped fields' id={'gender'}>
              <label htmlFor='gender'>Geschlecht</label>
              <Dropdown
                changeHandler={val => handleGenderUpdate(val as Gender)}
                options={Object.values(Gender).map(gender => ({
                  value: gender,
                  text: translations['Gender'][gender]
                }))}
                currentValue={gender}
              />
            </div>
          </div>
          <div className='column'>
            <div className='grouped fields'>
              <label htmlFor=''>Ausbildung</label>
              <Dropdown
                changeHandler={val => handleEducationUpdate(val as Education)}
                options={Object.values(Education).map(edu => ({
                  value: edu,
                  text: translations['Education'][edu]
                }))}
                currentValue={education}
              />
            </div>
          </div>
        </div>

        <div className='one column row stackable'>
          <div className='right aligned column'>
            <div
              onClick={handleSkip}
              className='ui basic icon right labeled primary button'
            >
              Zu den Resultaten ohne Angabe von demografischen Daten
              <i className='right chevron icon' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
